import { LOAN_STATUS_TRANSLATED } from '../Enums'

export function convertStatusToLang(status: string): string {
  return LOAN_STATUS_TRANSLATED[status] || 'Status não identificado'
}
